<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/equipment/equipment-list' }">设备管理</el-breadcrumb-item>
          <el-breadcrumb-item >设备详情</el-breadcrumb-item>
        </el-breadcrumb>
    </div>

<!-- 1.基本信息 -->
      <div class="equipment-message">
        <!-- <dv-border-box-12 > -->
          <div class="base-message">
            <div class="header-common">
              <div class="header-common-left">
                <div class="title">基本信息</div>
              </div>
              <div class="header-common-right" v-if="showActionDelete==true">
                <el-button
                  class="right-button-out"
                  @click="deleteEquip()"
                  type="text"
                  >
                  注销
                </el-button>
              </div>
            </div>
            <div>
                <el-descriptions
                :column="2"
                border
                :contentStyle="contentStyle"
                :labelStyle='labelStyle'
                >
                  <el-descriptions-item label="使用单位" >
                    <span >{{hospitalName}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="所在地区" >
                    <span >{{area.provinceName}}/{{area.cityName}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="产品名称" >
                    <span >{{typeName}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="规格型号" >
                    <span >{{typeModel}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="设备UDI" >
                    <span >{{udi}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="注册日期" >
                    <span >{{registerDate}}</span>
                  </el-descriptions-item>
                  <!-- <el-descriptions-item label="出库日期" >
                    <span >{{shipDate}}</span>
                  </el-descriptions-item> -->
                  <el-descriptions-item label="使用次数" >
                    <span >{{surgeryAmount}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="耗材数量" >
                    <span >{{consumableUsedAmount}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="当前状态">
                    <span style="float: left;">{{statusText}}</span>
                    <div class="" style="float: left;margin-left: 20px;" v-if="realtime.status">
                      <p>气源压力：<span>{{realtime.pressure}} (psi)</span></p>
                      <p style="float: left;">冷机01
                        <div style="float: left;display: flex;flex-direction: row;">
                          <p style="margin-left: 20px;">温度：<span>{{realtime.r01Temp}} (℃)</span></p>
                          <p style="margin-left: 20px;">错误码：<span>{{realtime.r01ErrorCode}}</span></p>
                        </div>
                      </p>
                      <p style="float: left;">冷机02
                        <div style="float: left;display: flex;flex-direction: row;">
                          <p style="margin-left: 20px;">温度：<span>{{realtime.r02Temp}} (℃)</span></p>
                          <p style="margin-left: 20px;">错误码：<span>{{realtime.r02ErrorCode}}</span></p>
                        </div>
                      </p>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item label="定位数据" v-if="location.time">
                    <span >经度：{{location.longitude}}</span>
                    <br />
                    <span >纬度：{{location.latitude}}</span>
                    <br />
                    <span >定位时间：{{location.time}}</span>
                  </el-descriptions-item>
                </el-descriptions>
            </div>
          </div>
        <!-- </dv-border-box-12> -->
      </div>

      <!-- 使用记录和维护记录 -->
      <div class="tabs-content">
          <div class="condition">
            <div style="">
              <el-tabs
              type="border-card"
              style="background-color: transparent;border: 1px solid #1A3F81;border-radius: 12px;"
              v-model="activeName"
              @tab-click="handleClick"
              class="tabs-style"
              >
                <el-tab-pane style="background-color: transparent;" name="relationUser">
                  <span slot="label"><i class="el-icon-date"></i> 关联账号</span>
                  <div class="list-used">
                      <div class="header-common">
                        <div class="header-common-left">
                          <div class="title">设备关联账号</div>
                        </div>
                        <!-- <div class="header-common-right">
                          <el-button
                            class="right-button-export"
                            @click="exportUsedTable"
                            type="text"
                            >
                            导出
                          </el-button>
                        </div> -->
                      </div>
                      <div >
                        <el-table
                          :data="relatedUsers"
                          row-key="id"
                          border
                          default-expand-all
                          border
                          :cell-style="tableCellStyle"
                          :header-cell-style="tableHeaderCellStyle"
                          :max-height="tableHeight"
                          >
                            <el-table-column
                              type="index"
                              label="序号">
                            </el-table-column>
                            <el-table-column
                              prop="username"
                              label="账号名">
                            </el-table-column>
                            <el-table-column
                              prop="nickname"
                              label="用户姓名">
                            </el-table-column>
                            <el-table-column
                              prop="phone"
                              label="手机号">
                            </el-table-column>
                            <el-table-column
                              label="操作"
                              >
                              <template slot-scope="scope">
                                <button v-if="showActionUpdate==true" class="action-button-finish" @click="unbindAccount(scope.row.userId)">解绑</button>
                              </template>
                            </el-table-column>
                        </el-table>
                      </div>
                  </div>
                </el-tab-pane>

                  <el-tab-pane style="background-color: transparent;" name="equipUsed">
                    <span slot="label"><i class="el-icon-date"></i> 使用记录</span>
                    <div class="list-used">
                        <div class="header-common">
                          <div class="header-common-left">
                            <div class="title">设备使用记录</div>
                          </div>
                          <div class="header-common-right">
                            <el-button
                              class="right-button-export"
                              @click="exportUsedTable"
                              type="text"
                              >
                              导出
                            </el-button>
                          </div>
                        </div>
                        <div >
                          <el-table
                            v-loading='loading'
                            :data="tableData"
                            row-key="id"
                            border
                            default-expand-all
                            border
                            :cell-style="tableCellStyle"
                            :header-cell-style="tableHeaderCellStyle"
                            :max-height="tableHeight"
                            >
                              <el-table-column
                                type="index"
                                label="序号">
                              </el-table-column>
                              <el-table-column
                                prop="startTime"
                                width="135"
                                label="使用时间">
                              </el-table-column>
                              <el-table-column
                                prop="consumableQuantity"
                                width="50"
                                label="耗材数量">
                              </el-table-column>
                              <el-table-column
                                label="耗材列表"
                                width="350"
                                >
                                <template slot-scope="scope">
                                  <div v-for="(val,index) in scope.row.consumables" style="border: 2px solid #1A3F81;margin-bottom: 10px;border-radius: 3px;padding: 5px;background-color: transparent;display: flex;flex-direction: column;align-items: flex-start;">
                                    <div>使用时间：{{val.useTime}}</div>
                                    <div>耗材类型：{{val.type}}</div>
                                    <div>耗材UDI：{{val.udi}}</div>
                                  </div>
                                </template>
                              </el-table-column>
                              <el-table-column
                                label="使用数据"
                                >
                                <template slot-scope="scope">
                                  <el-descriptions
                                  class="margin-top"
                                  :column="3" border
                                  :contentStyle="contentStyle"
                                  :labelStyle='labelStyle'
                                  v-if="scope.row.patient"
                                  >
                                  <el-descriptions-item label="ID" >
                                    <span>{{scope.row.patient.pid}}</span>
                                  </el-descriptions-item>
                                  <el-descriptions-item label="年龄" >
                                    <span >{{scope.row.patient.age}}</span>
                                  </el-descriptions-item>
                                    <el-descriptions-item label="消融针数量" >
                                      <span>{{scope.row.consumableQuantity}}</span>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="部位" >
                                      <span >{{scope.row.patient.part}}</span>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="性别">
                                      <span v-if="scope.row.patient.gender==1">男</span>
                                      <span v-else>女</span>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="手术时长" >
                                      <span >{{scope.row.durationText}}</span>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="温度曲线" >
                                      <router-link
                                      class="action-button-base"
                                      :to="{path:'/manage/equipment/equipment-using-record-one',query:{id:id,sid:scope.row.surgeryId}}">
                                        查看温度曲线
                                      </router-link>
                                    </el-descriptions-item>
                                  </el-descriptions>
                                </template>
                              </el-table-column>
                          </el-table>
                        </div>
                    </div>
                  </el-tab-pane>

                  <el-tab-pane name="equipMaintain" v-if="showMaintain==true">
                    <span slot="label"><i class="el-icon-date"></i> 维护记录</span>
                    <div class="list-used">
                        <div class="header-common">
                          <div class="header-common-left">
                            <div class="title">设备维护记录</div>
                          </div>
                          <div class="header-common-right">
                            <el-button
                              class="right-button-export"
                              @click="exportMaintainTable"
                              type="text"
                              >
                              导出
                            </el-button>
                          </div>
                        </div>
                        <div >
                          <el-table
                            v-loading='loading'
                            :data="tableData"
                            border
                            default-expand-all
                            border
                            :cell-style="tableCellStyle"
                            :header-cell-style="tableHeaderCellStyle"
                            :max-height="tableHeight"
                            >
                              <el-table-column
                                type="index"
                                label="序号">
                              </el-table-column>
                              <el-table-column
                                prop="faultTime"
                                label="故障时间">
                              </el-table-column>
                              <el-table-column
                                prop="faultLog"
                                label="故障日志">
                              </el-table-column>
                              <el-table-column
                                prop="maintainStartTime"
                                label="开始处理时间">
                              </el-table-column>
                              <el-table-column
                                prop="maintainFinishTime"
                                label="结束处理时间"
                                >
                              </el-table-column>
                              <el-table-column
                                prop="maintainDuration"
                                label="处理时长(分钟)"
                                >
                              </el-table-column>
                              <el-table-column
                                prop="maintainProcess"
                                label="维护内容">
                              </el-table-column>
                              <el-table-column
                                prop="maintainerName"
                                label="维护人">
                              </el-table-column>
                              <el-table-column
                                prop="maintainStatusText"
                                label="处理状态">
                              </el-table-column>
                          </el-table>
                        </div>
                    </div>
                  </el-tab-pane>
              </el-tabs>
            </div>

          </div>
      </div>
  </div>

</template>

<script>
  import {dataConversionUtil} from '../../../utils/excel.js'
  import {areaSingleConversionUtil} from '../../../utils/povince_handle.js'
  import {permissionCheckUtil} from '../../../utils/permission.js'

  export default {
    data() {
      return{
        contentStyle:{
          'border':'1px solid #1A3F81',
          'color' : '#fff',
          'font-size': '15px',
          'font-weight': 'solid',
          'border-bottom':'0px solid #1A3F81',
          'border-right':'0px solid #1A3F81'
        },
        labelStyle:{
          'width': '108px',
          'height': '20px',
          'font-size': '14px',
          'font-weight': 'bold',
          'color': '#00FFFF',
          'background-color':'transparent',
          'border':'1px solid #1A3F81',
          'border-bottom':'0px solid #1A3F81',
        },
        showActionDelete:false,
        showActionUpdate:false,
        showMaintain:false,

        activeName:'relationUser',
        tableHeight:0,

        //设备信息
        id:'',//设备ID
        area:{
          provinceCode:'',
          provinceName:'',
          cityCode:'',
          cityName:'',
        },
        hospitalName:'',
        typeName:'',
        typeModel:'',
        registerDate:'',
        shipDate:'',
        relatedUsers:[],//关联账号
        udi:'',
        statusText:'',
        status:0,
        realtime:{
          // status:'',
          // pressure:0,
          // r01Temp:0,
          // r01ErrorCode:'',
          // r02Temp:0,
          // r02ErrorCode:''
        },
        location:{
          // langgitude:'',
          // atitude:'',
          // time:''
        },
        surgeryAmount:0,//设备使用次数
        consumableUsedAmount:0,//耗材消耗
        salesUser:'',//关联销售
        // salesNickname:'',
        maintainUser:'',//关联维护
        // maintainNickname:'',
        doctorUser:'',//关联医护
        // doctorNickname:'',

        tableData:[],

        loading:false,
      }
    },
    methods: {
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;text-align:left;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:left;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },

      handleNumber(number){
      	if(number < 10){
      		return '0' + number;
      	}

      	return number
      },
      handleClick(tab, event){
        if (tab.name == 'equipUsed') {
          this.getUsedList()
        } else if (tab.name == 'equipMaintain'){
          this.getMaintainList()
        }
      },
      // 设备使用记录
      getUsedList(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/surgery';
        const data = {"id":parseInt(this.id)}

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              //使用记录
              if(obj.data.surgeries){
                this.tableData = obj.data.surgeries;

                for(var index=0;index<obj.data.surgeries.length;index++){
                  var element = obj.data.surgeries[index];
                  // 时长
                  var second = element.duration;
                  var durationText = this.handleNumber(parseInt(second/3600)) + ':' + this.handleNumber(parseInt((second%3600)/60)) +  ':' + this.handleNumber(parseInt((second%3600)%60));
                  element.durationText = durationText;
                }
              }
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      // 维护记录
      getMaintainList(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/maintenance';
        const data = {"id":parseInt(this.id)}

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          this.tableData = []
          var obj = res.data;
            if(obj.code == 0){
                if(obj.data.maintenances){
                  var array = obj.data.maintenances;
                  for(var i=0;i<array.length;i++){
                    var element = array[i];
                    if(element.maintainStatus == 1){
                      element.maintainStatusText = '未处理'
                    }else if(element.maintainStatus == 1){
                      element.maintainStatusText = '处理中'
                    }else {
                      element.maintainStatusText = '处理完成'
                    }
                    this.tableData.push(element)
                  }
                }
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading = false
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getEquipmentDetail(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/detail';
        const data = {"id":this.id}

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.udi = obj.data.udi;
              this.area.provinceCode = obj.data.provinceCode;
              this.area.cityCode = obj.data.cityCode;
              this.hospitalName = obj.data.hospitalName;
              this.typeName = obj.data.typeName;
              this.typeModel = obj.data.typeModel;
              this.relatedUsers = obj.data.relatedUsers;

              if(this.area.provinceCode){
                areaSingleConversionUtil.codeToName(this.area)
              }

              if(obj.data.location){
                // this.reverseGeocoding(obj.data.location.latitude,obj.data.location.longitude);
                this.location.latitude = obj.data.location.latitude
                this.location.longitude = obj.data.location.longitude
                this.location.time = obj.data.location.time
              }

              this.status = obj.data.status
              if(obj.data.status==1){
                this.statusText = '正常'
              }else if(obj.data.status==2){
                this.statusText = '关机'
              }else if(obj.data.status==3){
                this.statusText = '故障'
              }else{
                this.statusText = '手术中'
              }

              this.registerDate = obj.data.registerDate;
              this.shipDate = obj.data.shipDate;

              //实时数据
              if(obj.data.realtime){
                this.realtime.status = obj.data.realtime.status
                this.realtime.pressure = obj.data.realtime.pressure
                this.realtime.r01Temp = obj.data.realtime.r01Temp
                this.realtime.r01ErrorCode = obj.data.realtime.r01ErrorCode
                this.realtime.r02Temp = obj.data.realtime.r02Temp
                this.realtime.r02ErrorCode = obj.data.realtime.r02ErrorCode
              }

              // 设备使用次数
              if(obj.data.surgeryAmount<=0){
                this.surgeryAmount = 0
              }else{
                this.surgeryAmount = obj.data.surgeryAmount;
              }
              //耗材消耗量
              if(obj.data.consumableUsedAmount<=0){
                this.consumableUsedAmount = 0
              }else{
                this.consumableUsedAmount = obj.data.consumableUsedAmount
              }
              // 所在医院耗材库存量
              // if(obj.data.consumableUnusedAmount<=0){
              //   this.consumableUnusedAmount = 0
              // }

            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      reverseGeocoding(latitude,longitude){
        // const headers = {
        //     'Authorization': localStorage.getItem('token')
        // }
        // const ak = 'Ql9N4M5FQ4lswyLSARwqG6B9UhUSaa1K';
        // const url = 'https://api.map.baidu.com/reverse_geocoding/v3/?ak='+ak+'&output=json&coordtype=wgs84ll&location='+longitude','+latitude;

        // axios.get(url)
        // .then(res=>{
        //   alert(JSON.stringify(res))
        // })
        // .catch(err=>{
        //   alert(JSON.stringify(err))
        // })
        // this.$http({
        //   method:'GET',
        //   url:url
        // }).then(res=>{
        //   alert(JSON.stringify(res))
        //   if(res.status == 200){//请求成功
        //   var obj = res.data;
        //     if(obj.code == 0){
        //     }else{
        //       this.$message.error(obj.message)
        //     }
        //   }else{
        //     this.$message.error(res.data.message);
        //   }

        // }).catch(err=>{
        //   alert(JSON.stringify(err))
        //   if(!err.response){
        //     this.$message.error(err.message);
        //   }else{
        //     this.$message.error(err.response.data.message);
        //   }
        // })
      },
      judgePermissions(){
          let per1 = permissionCheckUtil.findName("equipment:delete");
          let per2 = permissionCheckUtil.findName("equipment:update");
          let per3 = permissionCheckUtil.findName("equipment:maintain");


          if(per1==true){
            this.showActionDelete = true;
          }
          if(per2==true){
            this.showActionUpdate = true;
          }

          if(per3==true){
            this.showMaintain = true
          }
      },
      deleteEquip() {
        this.$confirm('此操作将永久删除该设备，是否继续？','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
        }).then(() => {
          this.deleteEquipAction();
        }).catch(() => {
          this.$message({
            type:'info',
            message:'取消删除'
          })
        })
      },
      deleteEquipAction(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/delete';
        const data = {"id":this.id}

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                type:'success',
                message:'已注销'
              })
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      unbindAccount(userId){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/relation/delete';
        const data = {
          'userId':userId,
          'equipmentId':this.id,
        }
        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                type:'success',
                message:'解绑成功'
              })
              this.getEquipmentDetail()
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      // 导出
      exportUsedTable(){
        var tableHeader = [['序号','使用时间','患者ID','年龄','性别','部位','手术时长','消融针数量','耗材列表']];

        var dataList = [];
        this.tableData.forEach((item,index)=>{
          var array = [];
          array.push(index+1);
          array.push(item.startTime);
          array.push(item.patient.pid);
          array.push(item.patient.age)
          array.push(item.patient.gender=1?'男':'女')
          array.push(item.patient.part)
          array.push(item.durationText)
          array.push(item.consumableQuantity)
          for(var i=0;i<item.consumables.length;i++){
            var element = item.consumables[i];
            var text = '使用时间:'+element.useTime + ';' + '类型:'+element.type + ';'+'UDI:'+element.udi;
            array.push(text);
          }
          dataList.push(array);
        });

        if(dataList.length > 0){
          dataConversionUtil.dataToExcel(this.udi+'-设备使用记录',tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }

      },
      exportMaintainTable(){
        var tableHeader = [['序号','故障时间','故障日志','开始处理时间','结束处理时间','处理时长(分钟)','维护内容','维护人','处理状态']];
        var dataList = [];
        this.tableData.forEach((item,index)=>{
          dataList.push([
            index+1,
            item.faultTime,
            item.faultLog,
            item.maintainStartTime,
            item.maintainFinishTime,
            item.maintainDuration,
            item.maintainProcess,
            item.maintainerName,
            item.maintainStatusText
          ]);
        });
        
        if(dataList.length > 0){
          dataConversionUtil.dataToExcel(this.udi+'-设备维护记录',tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }
        
      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-620 < 300 ? 300 : window.innerHeight-620;
        })
      },
    },
    created() {
      this.judgePermissions()

      this.id = this.$route.query.id;

    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)

      this.sizeFun()

      // 设备基本信息
      this.getEquipmentDetail()
      this.getUsedList()
    }
  }
</script>


<style lang="scss" scoped>
.container{
  margin-top: $header-height;

  .bread >>>.el-breadcrumb__inner{
    color: #606266;
    font-weight: 400;
  }

  .equipment-message{

    .base-message{
      // padding: 6px 2px 20px 6px;

    }
  }

  .tabs-content{
    margin-top: $main-padding;

      .action-button-base{
        width: 100px;
        height: 36px;
        border: 1px solid rgba(255,132,0,0.84);
        border-radius: 18px;
        font-size: 14px;

        font-weight: 400;
        color: #FFCC00;
        background-color: #8D5620;

        display: inline-block;
        line-height: 36px;
        text-align: center;
        text-decoration: none;
      }

      .action-button-finish{
        float: right;
        width: 89px;
        height: 36px;
        background: #FAFAFA;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
      }

  }



  // 公共头部样式

  .header-common{
    width: 100%;
    height: 45px;
    border-radius: 12px 12px 0 0 ;
    background: linear-gradient(-90deg, #001940, #1564BE);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    // margin-right: 26px;

    .header-common-left{
      font-size: 20px;
      font-weight: bold;
      color: #FEFEFE;
      margin-left: 21px;

      .title{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
      }
    }
    .header-common-right{

      .right-button{
        width: 89px;
        height: 40px;
        background: #FAFAFA;
        border: 1px solid rgba(0,255,96,0.84);
        border-radius: 20px;
        background-color: #208D7F;
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
        margin-right: 20px;
      }

      .right-button-out{
        width: 89px;
        height: 40px;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
        margin-right: 20px;
      }
      .right-button-export{
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
        margin-right: 20px;
      }
    }

  }

}

</style>



// WEBPACK FOOTER //
// src/view/manage/equipment/equipment-details.vue